import _ from 'lodash';
import { mapGetters } from 'vuex';

const createField = (name, caption, dataFn, filterFn = () => true) => ({
  name,
  caption,
  data: dataFn,
  filterFn,
});

const availableFields = [
  createField('target.locations', 'campaign_field.title.area',
    (c, t) => c.locations
      .map(l => t('campaign_field.format.location', { name: l.name, type: l.type }))
      .join(', '),
  ),
  createField('target.radius', 'campaign_field.title.radius',
    (c, t) => t('campaign_field.format.radius', {
      radius: c.radius,
      unit: c.distance_unit,
    }),
  ),
  createField('target.age-gender', 'campaign_field.title.age-gender',
    (c, t) => t('campaign_field.format.gender-and-age', {
      from: c.ages.from,
      to: c.ages.to,
      genders: c.genders,
    }),
  ),
  createField('target.interests', 'campaign_field.title.interests',
    (c, t, box) => box.interests
      .filter(i => c.interests.indexOf(i.id) !== -1)
      .map(i => {
        const key = `terms.interests.${i.slug}.name`;
        if (key === t(key)) {
          return i.name;
        }
        return t(key);
      })
      .join(', '),
  ),
  createField('target.language', 'campaign_field.title.language',
    (c, t) => t('fn.complex.language', { code: _.get(c, 'language') }),
  ),
  createField('reach.potential', 'campaign_field.title.potential-reach',
    (c, t) => t('campaign_field.format.potential-reach', { reach: c.potential_reach }),
  ),
];

export default {
  props: {
    target: {
      type: Object,
      default: null,
    },
    target_change_status: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('interests', ['interests']),
    changedTargetFields() {
      return availableFields
        .map(f => ({
          name: this.$t(f.caption),
          value: f.data(this.target, this.$t.bind(this), this),
        }));
    },
  },
  methods: {
    openTargetChangeModal() {
      this.$refs.modal.show();
    },
    cancel() {
      this.$refs.modal.hide();
    },
    isEmpty(value) {
      return _.isEmpty(value) ? '-' : value;
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/campaign-target-popup/CampaignTargetPopup.js